import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '../../components/shared/Badge/Badge';
import { RequestTag } from '../../services/service-evaluations';
import { TAG_ARCHIVED_LABEL, TAG_CHIP_STYLE } from '../../util/evaluationStatusMeta';
import styles from './page-supplier-evaluations.module.scss';

type Props = {
  tags: RequestTag[];
};

const TagChips: FC<Props> = ({ tags }) => {
  const [t] = useTranslation('evaluations');
  if (!tags.length) return null;

  return (
    <div className={styles.tagRow}>
      {tags.map(tag => (
        <Badge
          key={tag._id}
          className={styles.tagChip}
          color={TAG_CHIP_STYLE.color}
          backgroundColor={TAG_CHIP_STYLE.backgroundColor}
        >
          {tag.name}
          {tag.archived && (
            <span className={styles.muted}>
              {` · ${t(TAG_ARCHIVED_LABEL.labelKey, TAG_ARCHIVED_LABEL.fallback)}`}
            </span>
          )}
        </Badge>
      ))}
    </div>
  );
};

export default TagChips;
